module.exports = "/_next/static/images/icon_weather_43-53c0b269f1c20c5024b668032e6ee6cc.svg";